import React from "react";
import "./style.css";

const Footer = () => {
    return (
        <footer className="bg-primary text-white text-center fixed-bottom mt-4 p-3">
            <h4>&copy; Made with ❤️️ by Philip DiPaula</h4>
        </footer>
    )
};

export default Footer;